import React from 'react';

const cx = (...a) => a.filter(Boolean).join(' ');

const sizeMap = {
    xs: 'text-xs',
    sm: 'text-sm',
    md: 'text-base',
};

const weightMap = {
    normal: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold',
};

const colorMap = {
    default: 'text-gray-800',
    muted: 'text-gray-500',
    primary: 'text-blue-600',
    neutral: 'text-gray-700',
    success: 'text-green-600',
    warning: 'text-amber-600',
    danger: 'text-red-600',
};

const alignMap = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right',
};

export default function Label({
    as: As = 'span',
    children,
    size = 'xs',
    weight = 'medium',
    color = 'muted',
    uppercase = false,
    align = 'left',
    className = '',
    style,
}) {
    const classes = cx(
        sizeMap[size] || sizeMap.xs,
        weightMap[weight] || weightMap.medium,
        colorMap[color] || colorMap.muted,
        alignMap[align] || alignMap.left,
        uppercase && 'uppercase tracking-wide',
        'leading-none',
        className
    );

    return (
        <As className={classes} style={style}>
            {children}
        </As>
    );
}